export const quickAnswer =
  'Check your active objective and prerequisite questline first. Power Lines and Into the Sinkhole both follow Arish\u2019s Briefing.';

## Focused Quest Help

These guides cover specific blockers rather than every mission. Use the mission name in your journal to choose the matching walkthrough.

## Progression Can Run in Parallel

Completing one thread does not necessarily clear every prerequisite in another. Check outstanding objectives before assuming the game is stuck.

## Combat Blocking Progress?

Read [Build Power](/guides/build-power) before revisiting a difficult encounter.
